var Vue = require('vue');
var PhoneField = require('../../lib/components/Fields/PhoneField.vue').default;
var FileUploadFieldWrapper = require('../../modules/fields/components/FileUploadWrapper').default;
var store = require('../../lib/store/index').default;

export default function() {

  const phoneWrappers = document.getElementsByClassName('phone-field-wrapper');
  let vuePhoneWrappers = [];
  if (phoneWrappers) {
    Array.prototype.forEach.call(phoneWrappers, phoneWrapper => {
      vuePhoneWrappers.push(new Vue({
        el: phoneWrapper,
        components: {
          'phone-field': PhoneField
        }
      }));
    });
  }
  let vueFileFieldWrappers = [];
  const fileUploadFieldWrappers = document.getElementsByClassName('upload-field-wrapper');
  if (fileUploadFieldWrappers) {
    Array.prototype.forEach.call(fileUploadFieldWrappers, fileUploadFieldWrapper => {
      vueFileFieldWrappers.push(new Vue({
        el: fileUploadFieldWrapper,
        components: {
          'file-upload-field-wrapper': FileUploadFieldWrapper,
        },
        store
      }));
    });
  }

  $(document).one('pjax:end', () => {
    vuePhoneWrappers.forEach(fieldWrapper => {
      fieldWrapper.$destroy();
    });

    vueFileFieldWrappers.forEach(fieldWrapper => {
      fieldWrapper.$destroy();
    });
  });
}
